import { useState, useEffect } from "react";
import { Form, Button, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { useHistory } from "react-router";
import Infoikoon from "../../images/Infoikoon.png";
import {useTranslation} from 'react-i18next';

const CodeForm = () => {
    
    const [codeForm, setCodeForm] = useState({ hnr: '', snr: '', lbn: '' });
    const history = useHistory();
    const hnr = useQuery().get('hnr');
    const snr = useQuery().get('snr');
    const lbn = useQuery().get('lbn');
    const [formError, setFormError] = useState("");
    const {t} = useTranslation();

    const codeSearchClicked = async (e: Event) => {
        e.preventDefault();
        localStorage.removeItem('scrollPosition');
        localStorage.removeItem("networkFilter");
        localStorage.removeItem("conditionFilter");
        if (codeForm.hnr !== "" || codeForm.snr !== "" || codeForm.lbn !== "") {
            history.push("/multiplelocations/code?hnr=" + codeForm.hnr + "&snr=" + codeForm.snr + "&lbn=" + codeForm.lbn);
        } else {
            setFormError(t('inputError').toString());
        }

    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                {t('codeSearchPopoverText1')}<br />
                {t('codeSearchPopoverText2')}<br />
                {t('codeSearchPopoverText3')}
            </Popover.Body>
        </Popover>
      );

    function useQuery() {
        return new URLSearchParams(window.location.search);
    }

    function addHnr(input: string) {
        if (isNaN(Number(input))) {
            setFormError(t('onlyNumbersError').toString());
            return null;
        }
        setFormError("");
        setCodeForm({ ...codeForm, hnr: input.trim() })
    }

    function addSnr(input: string) {
        if (isNaN(Number(input))) {
            setFormError(t('onlyNumbersError').toString());
            return null;
        }
        setFormError("");
        setCodeForm({ ...codeForm, snr: input.trim() })
    }
    
    function addLbn(input: string) {
        if (isNaN(Number(input))) {
            setFormError(t('onlyNumbersError').toString());
            return null;
        }
        setFormError("");
        setCodeForm({ ...codeForm, lbn: input.trim() })
    }

    useEffect(() => {
        setCodeForm({ hnr: hnr ? hnr : "", snr: snr ? snr : "", lbn: lbn ? lbn : "" })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Form>
                <Row>
                    <Col md="auto">
                        {t('codeSearchCodeNumberText') + " "}
                        <OverlayTrigger placement="top" overlay={popover}>
                            <img className="search-icon" src={Infoikoon} alt="Info"/>
                        </OverlayTrigger>
                    </Col>
                    <Col>
                        <Form.Control value={codeForm.hnr} onChange={e => addHnr(e.target.value)} type="text" size="sm" aria-label="hnr" maxLength={2} />
                    </Col>
                    <Col>
                        <Form.Control value={codeForm.snr} onChange={e => addSnr(e.target.value)} type="text" size="sm" aria-label="snr" maxLength={3} />
                    </Col>
                    <Col>
                        <Form.Control value={codeForm.lbn} onChange={e => addLbn(e.target.value)} type="text" size="sm" aria-label="lbn" />
                    </Col>
                    <Col>
                        <Button onClick={(e) => codeSearchClicked(e.nativeEvent)} type="submit" aria-label="otsi">{t('searchButtonLabel')}</Button> {" "}
                    </Col>
                </Row>
                {formError !== "" && 
                    <Row>
                        <Col>
                            <span className="error-message">{formError}</span>
                        </Col>
                    </Row>
                }   
            </Form>

        </>
    );

}

export default CodeForm;

